var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{staticClass:"self-cleaning",attrs:{"visible":true,"before-close":_vm.handleClose,"title":_vm.$t('自校准'),"width":"500px","top":"30vh"}},[_c('HTForm',_vm._b({attrs:{"i18nPath":_vm.i18nPath}},'HTForm',_vm.formOptions,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }